import cookies from './util.cookies'
import db from './util.db'
import log from './util.log'

const util = {
  cookies,
  db,
  log
}

/**
 * @description 更新标题
 * @param {String} title 标题
 */
util.title = function (title, config) {
  let siteName = ''
  if (config) {
    siteName = config.siteName // + config.siteShortName;
  }
  // const siteName = window.siteName + window.siteShortName;
  window.document.title = `${siteName}${title ? ` | ${title}` : ''}`
}

/**
 * @description 打开新页面
 * @param {String} url 地址
 */
util.open = function (url, target) {
  target = target || '_blank'
  let a = document.createElement('a')
  a.setAttribute('href', url)
  a.setAttribute('target', target)
  a.setAttribute('id', 'd2admin-link-temp')
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(document.getElementById('d2admin-link-temp'))
}

util.post = function (url) {
  let form = document.createElement('form')
  form.id = 'd2admin-form-temp'
  form.method = 'post'
  form.action = url
  form.target = '_blank'

  let ticket = cookies.get('token')
  let input = document.createElement('input')
  input.type = 'hidden'
  input.name = 'Authorization'
  input.value = ticket
  form.appendChild(input)

  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(document.getElementById('d2admin-form-temp'))
}

util.uuid = function () {
  let str = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    let r = Math.random() * 16 | 0
    let v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
  return str.replace('-', '')
}

util.pathInit = function ({
  dbName = 'database',
  path = '',
  user = true,
  validator = () => true,
  defaultValue = ''
}) {
  const uuid = this.cookies.get('ghost-uuid') || 'ghost-uuid'
  const currentPath = `${dbName}.${user ? `user.${uuid}` : 'public'}${path ? `.${path}` : ''}`
  const value = this.db.get(currentPath).value()
  if (!(value !== undefined && validator(value))) {
    this.db.set(currentPath, defaultValue).write()
  }
  return currentPath
}

export default util
